<script>
import FormBuilder from '../FormBuilder.vue'
import TeamTaskDataprovider from '../../../../services/teamtask'
import Toast from '../../Toast.vue'

export default {
  components: {
    FormBuilder,
    Toast,
  },
  props: {
    componentData: {
      default: {},
    },
    mainData: {
      default: {},
    },
    isProduct: {
      type: Boolean,
      default: false,
    },
    stopProductLoading: {
      default: null,
    },
  },
  data() {
    return {
      isToggled: false,
      keysArray: [],
      showToast: false,
      stopLoading: null,
    }
  },
  watch: {
    stopProductLoading(val) {
      if (val === true) {
        this.stopLoading = true
      }
    },
  },
  methods: {
    arrowToggle() {
      return (this.isToggled = !this.isToggled)
    },
    submitForm(e) {
      this.stopLoading = false
      if (this.isProduct) {
        this.$emit('productFormSubmited', e)
      } else {
        TeamTaskDataprovider.saveForm({
          key: this.mainData.key,
          id: this.componentData.id,
          formData: e,
        })
          .then((res) => {
            this.stopLoading = true
            this.showToast = true
            setTimeout(() => {
              this.showToast = false
            }, 2000)
          })
          .catch((err) => {
            setTimeout(() => {
              this.stopLoading = false
            }, 5000)
          })
      }
    },
  },
}
</script>

<template>
  <div style="border: 1px solid #f0f1f1; border-radius: 5px">
    <b-card-header v-if="componentData.title" header-tag="header" class="header" role="tab">
      <b-button @click="arrowToggle()" block v-b-toggle="componentData.id" class="w-100 button">
        <div class="inlineButton">
          <div class="buttonTitle">
            {{ componentData.title }}
          </div>
          <div>
            <i :class="{ down: isToggled, up: !isToggled }"> </i>
          </div>
        </div>
      </b-button>
    </b-card-header>
    <b-collapse v-if="componentData.title !== null" :id="componentData.id" visible :accordion="componentData.id" role="tabpanel">
      <b-card-body>
        <FormBuilder :stopLoading="stopLoading" @formSubmited="submitForm($event)" :formData="componentData.formData" :inputsData="componentData.defaultValues" />
      </b-card-body>
    </b-collapse>
    <div v-else>
      <FormBuilder
        :hasBottomMargin="false"
        :sectionBackground="true"
        @formSubmited="submitForm($event)"
        :formData="componentData.formData"
        :inputsData="componentData.defaultValues"
      />
    </div>
    <Toast title="با موفقیت ثبت شد" submit :showToast="showToast" />
  </div>
</template>
<style lang="scss" scoped>
.header {
  padding: 0;
  background: #f8f9fa;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.0520833);
  border-radius: 5px 5px 0 0;
  width: 100%;
}
.button {
  padding: 11px 20px;
  box-shadow: none;
  border: none;
  background: #f8f9fa;
}
::v-deep .collapsed {
  outline: none;
  border: none;
  background: #fafafa;
}
::v-deep .card-body {
  padding: 20px !important;
}
.buttonTitle {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #444444;
}
.collapse {
  border-top: none;
}
::v-deep .alert {
  padding: 0;
}
.inlineButton {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
i {
  border: solid #555555;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
}
.down {
  transform: rotate(-135deg);
}
.up {
  transform: rotate(45deg);
}
</style>
